/* ==========================================================================
   FOOTBALL-THEME :: Scroll motion
   - .fs-reveal  -> IntersectionObserver adds .is-inview (fade + rise).
   - .fs-progress -> a thin purple reading-progress bar pinned to the top.
   - [data-fs-parallax] -> elements drift slightly as they pass the viewport.
   Loaded from layout/theme.liquid (deferred). Respects prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Reveal on scroll -------------------------------------------------- */
  function markAll() {
    document.querySelectorAll('.fs-reveal').forEach(function (el) {
      el.classList.add('is-inview');
    });
  }

  if (reduced) {
    markAll();
  } else {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-inview');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
    );

    window.fsRegisterReveals = function (root) {
      (root || document).querySelectorAll('.fs-reveal:not(.is-inview)').forEach(function (el) {
        observer.observe(el);
      });
    };
    window.fsRegisterReveals(document);
  }

  /* 2. Progress bar ------------------------------------------------------ */
  var bar = null;
  if (!reduced) {
    bar = document.createElement('div');
    bar.className = 'fs-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
  }

  /* 3. Parallax ---------------------------------------------------------- */
  var parallax = [];

  function collectParallax(root) {
    (root || document).querySelectorAll('[data-fs-parallax]').forEach(function (el) {
      if (parallax.indexOf(el) === -1) parallax.push(el);
    });
  }

  var ticking = false;

  function update() {
    ticking = false;
    var vh = window.innerHeight;
    var max = document.documentElement.scrollHeight - vh;

    if (bar) {
      var p = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
      bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }

    if (reduced) return;

    for (var i = 0; i < parallax.length; i++) {
      var el = parallax[i];
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) continue;
      var speed = parseFloat(el.getAttribute('data-fs-parallax')) || 0.12;
      var center = r.top + r.height / 2 - vh / 2;
      var shift = -center * speed;
      var cap = 90;
      if (shift > cap) shift = cap;
      if (shift < -cap) shift = -cap;
      el.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  collectParallax(document);
  update();

  document.addEventListener('shopify:section:load', function (event) {
    if (window.fsRegisterReveals) window.fsRegisterReveals(event.target);
    collectParallax(event.target);
    onScroll();
  });
})();
